import { Box } from "@mui/material";
import NoData from "../ErrorMessage";
import DataTable from "../DataTable";

export default function DataTableTabContent({
    noData,
    data,
    title,
    dataSource
}) {
    if (noData) {
        return (
            <Box className="no-results" sx={{ m: 2 }}>
                <NoData
                    severity="warning"
                    text="No results for this country in this range of dates."
                />
            </Box>
        );
    }

    return (
        <DataTable
            data={data}
            tableTitle={title}
            download={true}
            dataSource={dataSource}
        />
    );
}
